import React from "react";
import Header from "./Header";
import {Outlet} from "react-router-dom";
import {Container} from "react-bootstrap";

const Base = () =>{

    return(
        <div>
            <Header/>
            <main className={'mt-4'}>
                <Container fluid={'lg'}>
                    <Outlet />
                </Container>
            </main>
        </div>
    );
}

export default Base;